import { lazy } from 'react';

const ProformaInvoicesPage = lazy(() => import('../pages/ProformaInvoices.page'));
const AddProformaInvoicePage = lazy(() => import('../pages/AddProformaInvoice.page'));

const ProformaInvoicesRoutes = [
    {
        path: '/proforma-invoices',
        element: <ProformaInvoicesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/proforma-invoices/add',
        element: <AddProformaInvoicePage />,
        layout: 'default',
        isAuthReq: true,
    },
];
export { ProformaInvoicesRoutes };
